<template>
  <div class="blank-section">
    <div class="section-title">
      <vk-icon-button
        class="back-icon"
        href="#"
        @click="$root.back()"
        icon="chevron-left"
      ></vk-icon-button>
      <h2>{{ table }} Detail #{{ id }}</h2>
    </div>
    <PageBuilder :table="table" :id="id" />
  </div>
</template>

<script>
import PageBuilder from "../components/PageBuilder/Page";
export default {
  name: "detail",
  components: { PageBuilder },
  created() {
    this.id = this.$route.params.id;
    this.table = this.$route.params.table;

    if (this.table == "leads") {
      this.$router.push("/leadDetail/" + this.id);
    } else {
      this.$router.push("/edit/" + this.table + "/" + this.id);
    }
  }
};
</script>
<style>
h2.title {
  padding-top: 20px;
}
</style>
